// Controls
import { Dropdown as FabricDropdown, Icon, useTheme } from "@fluentui/react";
// Styles
import { getCaretDownIconStyles, getDropdownStyleFunction } from "./Dropdown.style";
import { chevronDownIconProps } from "../../../icons/icons.styles";
// Utilities
import React, { useCallback } from "react";
import { css } from "@fluentui/utilities/lib/css";
export function Dropdown(props) {
    const theme = useTheme();
    const onRenderCaretDown = useCallback((props)=>/*#__PURE__*/ React.createElement(Icon, {
            ...chevronDownIconProps,
            styles: getCaretDownIconStyles(theme, props.disabled)
        }), [
        theme
    ]);
    const { children, ...passThroughProps } = {
        ...props,
        styles: props.isDefaultView ? {} : getDropdownStyleFunction(theme, props.disabled, props.styles),
        calloutProps: {
            ...props.calloutProps,
            className: css("unoAppCallout", props.calloutProps?.className)
        },
        onRenderCaretDown
    };
    return /*#__PURE__*/ React.createElement(FabricDropdown, passThroughProps, children);
}
